<template>
    <div class="popup" v-cloak v-if="isShow">
        <div class="content" id="emailPasteOption">
            <div class="title">
                <span v-if="isCut">{{$t('language.emailTransfer.cutSetting')}}</span>
                <span v-else>{{$t('language.emailTransfer.copySetting')}}</span>
                <div class="icon white-close dialog-close" @click="close()"></div>
            </div>
            <div class="popup-content">
                <div class="email-paste-options">
                    <div class="email-paste-option-title" v-if="isExists">{{$t('language.emailTransfer.settingTips')}}</div>
                    <div class="email-paste-option">
                        <div class="icon-util" :class="options.isSaveAtt?'check-small':'nocheck-small-blue'" @click="options.isSaveAtt=!options.isSaveAtt"></div>
                        <div>{{$t('language.emailTransfer.saveAtt')}}</div>
                    </div>
                    <div class="email-paste-option">
                        <div class="icon-util" :class="options.isConver?'check-small':'nocheck-small-blue'" @click="options.isConver=!options.isConver"></div>
                        <div>{{$t('language.emailTransfer.converFormat')}}</div>
                        <div class="icon-util question-mark">
                            <div class="plan-questionTxt">{{$t('language.emailTransfer.converFormatTip')}}</div>
                        </div>
                    </div>
                    <div class="email-paste-option">
                        <div class="icon-util" :class="options.isSaveOnly?'check-small':'nocheck-small-blue'" @click="options.isSaveOnly=!options.isSaveOnly"></div>
                        <div>{{$t('language.emailTransfer.saveOnly')}}</div>
                    </div>
                </div>
                <div class="email-paste-options" v-if="isExists">
                    <div class="email-paste-option-title">{{$t('language.emailTransfer.optionTitle')}}</div>
                    <div class="email-paste-option">
                        <div class="icon-util" :class="options.isDoExists==4?'check-radio':'radio'" @click="options.isDoExists=4"></div>
                        <div>{{$t('language.emailTransfer.filterOption1')}}</div>
                    </div>
                    <div class="email-paste-option">
                        <div class="icon-util" :class="options.isDoExists==2?'check-radio':'radio'" @click="options.isDoExists=2"></div>
                        <div>{{$t('language.emailTransfer.filterOption2')}}</div>
                    </div>
                    <div class="email-paste-option">
                        <div class="icon-util" :class="options.isDoExists==0?'check-radio':'radio'" @click="options.isDoExists=0"></div>
                        <div>{{$t('language.emailTransfer.filterOption3')}}</div>
                    </div>
                </div>
                <div class="popup-footer">
                    <button v-if="!loading" @click="paste()"><span>{{$t('language.common.ok')}}</span></button>
                    <button v-if="loading" ><span v-loading='loading'></span></button>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import commonUtils from "@/js/workspace/common_util.js";
import commonstate from '@/js/constant.js';
import cloudExploerUtils from "@/js/workspace/cloud_exploer_util.js";
import taskTransferUtils from '@/js/workspace/task_transfer_util.js';
export default {
    data: function (){
        return {
            isShow: false,
            isCut: false,//是否剪切
            isExists: false,//是否重名
            options: {
                isSaveAtt: true,
                isConver: true,
                isSaveOnly: false,
                isDoExists: 4,
                way: 'cloudEmail',
            },
            loading: false,
        }
    },
    methods: {
        init(isCut,isExists) {
            this.isCut = isCut;
            this.isExists = isExists;
            this.options = {
                isSaveAtt: true,
                isConver: true,
                isSaveOnly: false,
                isDoExists: 4,
                way: 'cloudEmail',
            };
            this.loading = false;
            this.isShow = true;
        },
        close(){
            this.isShow = false;
        },
        paste() { //用户根据弹窗然后选选项 跳过2 替换4 重命名0
            if (this.options.isDoExists == 5) {
                this.isShow = false;
                return false;
            }
            let cutData;
            let dataArr;
            let that = this;
            let options;
            let operate; //用于标识用户是复制还是剪切操作
            let aimItems;
            let trAimItem;
            let sourceItem;
            let remove;
            that.$store.state.cancelAllFlag = false;
            let snapUserId = commonUtils.getUserToLocal().id;
            if (this.$store.state.cutArr.length) { //如果是剪切数据
                dataArr = this.$store.state.cutArr;
            } else if (this.$store.state.copyArr.length) { //如果是复制数据
                dataArr = this.$store.state.copyArr;
            } else if (this.$parent.shareDataArr && this.$parent.shareDataArr.length) { //share用
                dataArr = this.$parent.shareDataArr;
            } else if (this.$parent.teamDataArr && this.$parent.teamDataArr.length) { //team用
                dataArr = this.$parent.teamDataArr;
            } else if (this.$parent.selectItemArr && this.$parent.selectItemArr.length) { //如果是父组件直接选中的数据，而不是打开的copy to 弹窗
                dataArr = this.$parent.selectItemArr;
            } else if (this.$store.state.previewData.length) { //如果是预览界面的数据
                dataArr = this.$store.state.previewData;
            }
            if ((this.$store.state.retryItems.length + dataArr.length) > 200) { //如果数据条数加起来大于200，则抛出提示
                let index = (this.$store.state.retryItems.length + dataArr.length) - 200;
                dataArr.splice(dataArr.length - index, dataArr.length + 1);
                this.$toast({
                    text: this.$t('language.cloudExploer.simultaneous'),
                    type: 'fail',
                    idValue: "rightBo"
                });
            }
            //如果是cloudExploer界面的复制传输
            if (that.$store.state.cutArr.length || that.$store.state.copyArr.length) {
                sourceItem = taskTransferUtils.createTransferFromItems(dataArr);
                let Base64 = require('js-base64').Base64;
                let aimJsonData;
                if (localStorage.getItem("cloudExploerPaste")) {
                    let cloudExploerPasteItems = JSON.parse(Base64.decode(localStorage.getItem("cloudExploerPaste")));
                    if (cloudExploerPasteItems) {
                        aimJsonData = cloudExploerPasteItems[that.$route.query.folderId];
                        if (!aimJsonData) {
                            aimJsonData = that.$parent.createAimItems();
                        }
                        } else {
                            aimJsonData = that.$parent.createAimItems();
                        }
                } else {
                    aimJsonData = that.$parent.createAimItems();
                }
                aimItems = taskTransferUtils.createTransferFromItems([aimJsonData]);

                if (that.$store.state.cutArr.length) {
                    options = { //如果是剪切状态
                        isRemove: 1,
                        isChar: 1,
                        replace: this.options.isDoExists,
                        operate: 'cut',
                        attachment: that.options.isSaveAtt,
                        conversationQuoted: that.options.isConver,
                        onlyLastMail: that.options.isSaveOnly,
                        way: 'cloudEmail',
                    }
                    remove = true;
                    operate = 'cut'; //如果是剪切状态
                } else { //如果是复制状态
                    options = {
                        isRemove: 0,
                        isChar: 1,
                        replace: this.options.isDoExists,
                        operate: 'copy',
                        attachment: that.options.isSaveAtt,
                        conversationQuoted: that.options.isConver,
                        onlyLastMail: that.options.isSaveOnly,
                        way: 'cloudEmail',
                    }
                    operate = 'copy'
                }
                // console.log(options)
                //判断是企业云盘不同子账号根目录的就是add接口
                var businessAddFlag = false;
                if (sourceItem[0].driveType == aimItems[0].driveType) {
                    if ((aimItems[0].driveType == 'gSuite' || aimItems[0].driveType == 'boxBusiness' || aimItems[0].driveType ==
                        'oneDrive4Business') && aimItems[0].fileId.indexOf(":") != -1) {
                        var args1 = aimItems[0].fileId.split(":");
                        var userEmailId1 = args1[0];
                        var args2 = sourceItem[0].fileId.split(":");
                        var userEmailId2 = args2[0];
                        if (userEmailId1 != userEmailId2) {
                            businessAddFlag = true;
                        }
                    }
                    if (aimItems[0].driveType == 'dropbox4Business' && aimItems[0].fileId.indexOf(":") != -1) {
                        var args1 = aimItems[0].fileId.split(":");
                        if (args1[2]) {
                            var userEmailId1 = args1[2];
                            var args2 = sourceItem[0].fileId.split(":");
                            var userEmailId2 = args2[2];
                            if (userEmailId1 != userEmailId2) {
                                businessAddFlag = true;
                            }
                        }
                    }
                }
                that.$store.state.snapTaskShow = true; //显示临时任务弹窗
                //1.如果是跨云盘的传输 2.如果是复制操作，是同云盘，但是不支持复制操作的 3.如果是剪切操作，是同云盘，但是不支持剪切操作的4.是企业云盘不同子账号根目录的就是add接口
                if ((operate == 'copy' && (sourceItem[0].driveType == aimItems[0].driveType) && commonstate.notSupportCopy
                    .includes(aimItems[0].driveType)) || (operate == 'cut' && (sourceItem[0].driveType == aimItems[0]
                    .driveType) && commonstate.notSupportCut.includes(aimItems[0].driveType)) || sourceItem[0].driveId !=
                    aimItems[0].driveId || sourceItem[0].driveType == "team" || aimItems[0].driveType == "team" ||
                    businessAddFlag) {
                    commonUtils.judgeNewDataFlag(that);
                    commonUtils.packageDetailData(sourceItem, aimItems, false);
                    let addData = new taskTransferUtils.addTaskData(snapUserId, 4, sourceItem[sourceItem.length - 1].filename,
                    sourceItem, aimItems, options, null);
                    that.Utils.doTasksRequest('add', addData).then(res => { //调用add接口
                        that.$store.state.cancelAllFlag = true;
                        if (res.status == 200) {
                            commonUtils.letFlagTrue(that);
                            commonUtils.packageHaveDataDetail(res.tasks);
                        } else if (res.status == 400 && res.reason == 'permissionFail') {
                            commonUtils.removeDataDetail(addData);
                            that.$parent.reFresh();
                            that.$toast({
                                text: that.$t('language.exception.notPermission'),
                                type: 'fail',
                                idValue: "rightBo",
                                duration: 5000
                            });
                        } else if (res.status == 400 && res.reason == 'notEnoughTimes'){
                            commonUtils.removeDataDetail(addData);
                            that.$parent.reFresh();
                          //弹出付费弹窗
                          var upgradeNewDialog = that.$parent.$refs.upgradeNewDialog;
                          upgradeNewDialog.title = that.$t('language.paySystem.freePlanPopup.title_pdf');
                          upgradeNewDialog.curItem = 'pdf';
                          upgradeNewDialog.isShow = true;
                          that.close()
                          return false;
                        }
                    });
                    that.close();
                    //若是除谷歌外同云盘传输
                } else {
                    that.$parent.snapTaskIconShow = true;
                    that.$store.state.snapTaskShow = true;
                    that.$store.state.cancelAllFlag = true;
                    commonUtils.judgePasteNewDataFlag(that);
                    commonUtils.letFlagTrue(that);
                    //若是支付剪切复制的同云盘传输 则调用paste/copy接口
                    $.each(dataArr, function(indexItem, Item) {
                        cutData = new cloudExploerUtils.movePasteData(snapUserId, Item.driveId, Item.pid, Item.id, aimItems[0]
                            .fileId, Item.name, null, Item.isDir);
                        that.$store.state.retryItems.push({
                            name: Item.name,
                            status: 'ready',
                            cutData: cutData,
                            operate: operate,
                            aimPid: Item.pid,
                            toDriveType: Item.driveType,
                        });
                    });
                    that.close();
                }
                //若是copy to传输
            } else if (dataArr.length && that.storeData.length) {
                options = {
                    isRemove: 0,
                    isChar: 1,
                    replace: this.options.isDoExists,
                    operate: 'copy',
                    attachment: that.options.isSaveAtt,
                    conversationQuoted: that.options.isConver,
                    onlyLastMail: that.options.isSaveOnly,
                    way: 'cloudEmail',
                }
                operate = 'copy'
                sourceItem = taskTransferUtils.createTransferFromItems(dataArr);
                trAimItem = taskTransferUtils.createTransferFromItems(that.storeData);
                var businessAddFlag = false;
                if (sourceItem[0].driveType == trAimItem[0].driveType) {
                    if ((trAimItem[0].driveType == 'gSuite' || trAimItem[0].driveType == 'boxBusiness' || trAimItem[0]
                        .driveType == 'oneDrive4Business') && trAimItem[0].fileId.indexOf(":") != -1) {
                    var args1 = trAimItem[0].fileId.split(":");
                    var userEmailId1 = args1[0];
                    var args2 = sourceItem[0].fileId.split(":");
                    var userEmailId2 = args2[0];
                    if (userEmailId1 != userEmailId2) {
                        businessAddFlag = true;
                    }
                    }
                    if (trAimItem[0].driveType == 'dropbox4Business' && trAimItem[0].fileId.indexOf(":") != -1) {
                    var args1 = trAimItem[0].fileId.split(":");
                    if (args1[2]) {
                        var userEmailId1 = args1[2];
                        var args2 = sourceItem[0].fileId.split(":");
                        var userEmailId2 = args2[2];
                        if (userEmailId1 != userEmailId2) {
                        businessAddFlag = true;
                        }
                    }
                    }
                }
                that.$store.state.snapTaskShow = true; //显示临时任务弹窗
                //若是跨云盘的传输
                if (((sourceItem[0].driveType == trAimItem[0].driveType) && commonstate.notSupportCopy.includes(trAimItem[0]
                    .driveType)) || sourceItem[0].driveId != trAimItem[0].driveId || businessAddFlag) {
                    commonUtils.judgeNewDataFlag(that);
                    commonUtils.packageDetailData(sourceItem, trAimItem, false);
                    let addData = new taskTransferUtils.addTaskData(snapUserId, 4, sourceItem[sourceItem.length - 1].filename,
                    sourceItem, trAimItem, options, null);
                    that.Utils.doTasksRequest('add', addData).then(res => {
                        that.$store.state.cancelAllFlag = true;
                        if (res.status == 200) {
                            commonUtils.letFlagTrue(that);
                            commonUtils.packageHaveDataDetail(res.tasks);
                        } else if (res.status == 400 && res.reason == 'permissionFail') {
                            commonUtils.removeDataDetail(addData);
                            that.$parent.reFresh();
                            that.$toast({
                            text: that.$t('language.exception.notPermission'),
                            type: 'fail',
                            idValue: "rightBo",
                            duration: 5000
                            });
                        } else if (res.status == 400 && res.reason == 'notEnoughTimes'){
                            commonUtils.removeDataDetail(addData);
                            that.$parent.reFresh();
                            //弹出付费弹窗
                            var upgradeNewDialog = that.$parent.$refs.upgradeNewDialog;
                            upgradeNewDialog.title = that.$t('language.paySystem.freePlanPopup.title_pdf');
                            upgradeNewDialog.curItem = 'pdf';
                            upgradeNewDialog.isShow = true;
                            that.close()
                            return false;
                        }
                    });
                    that.close();
                //若是除谷歌外同云盘传输
                } else {
                    that.$parent.snapTaskIconShow = true;
                    that.$store.state.snapTaskShow = true;
                    that.$store.state.cancelAllFlag = true;
                    commonUtils.judgePasteNewDataFlag(that);
                    commonUtils.letFlagTrue(that);
                    $.each(sourceItem, function(index1, Item) {
                        $.each(aimItems, function(aimIndex, aimItem) {
                            //如果是同云盘的数据
                            if (that.$store.state.treeMoveSelect) {
                                options = { //如果是剪切状态
                                    replace: this.options.isDoExists,
                                    isRemove: 1,
                                    isChar: 1,
                                    operate: 'cut',
                                    attachment: that.options.isSaveAtt,
                                    conversationQuoted: that.options.isConver,
                                    onlyLastMail: that.options.options.isSaveOnly,
                                    way: 'cloudEmail',
                                }
                                operate = 'cut'; //如果是剪切状态
                            } else { //如果是复制状态
                                options = {
                                    replace: this.options.isDoExists,
                                    isRemove: 0,
                                    isChar: 1,
                                    operate: 'copy',
                                    attachment: that.options.isSaveAtt,
                                    conversationQuoted: that.options.isConver,
                                    onlyLastMail: that.options.isSaveOnly,
                                    way: 'cloudEmail',
                                }
                                operate = 'copy';
                            }
                            cutData = new cloudExploerUtils.movePasteData(commonUtils.getUserToLocal().id, Item
                            .driveId, Item.pid, Item.fileId, aimItem.fileId, Item.filename, null, Item.isDir);
                            that.$store.state.retryItems.push({
                                name: Item.filename,
                                status: 'ready',
                                cutData: cutData,
                                operate: operate,
                                toDriveType: Item.driveType,
                                aimPid: Item.pid
                            });
                        });
                    });
                    that.close();
                }
            }
        },
    }
}
</script>
<style scoped>
#emailPasteOption {
    width: 500px;/*no*/
    height: fit-content;
}

.email-paste-options {
    font-size: 14px;/*no*/
    font-family: Arial;
    font-weight: 400;
    line-height: 21px;/*no*/
    margin-bottom: 30px;/*no*/
}

.email-paste-option-title {
    color: #6F7886;
    margin-bottom: 15px;/*no*/
}

.email-paste-option {
    display: flex;
}

.email-paste-option .icon-util {
    margin-top: 3px;/*no*/
    margin-right: 10px;/*no*/
    cursor: pointer;
}

.popup-content {
    padding: 20px;/*no*/
}

.popup-footer {
    margin-top: 40px;/*no*/
    text-align: right;
}

.popup-footer button{
    min-width:82px;/*no*/
    padding: 0 20px;/*no*/
}

.question-mark{
  margin: 0 !important;
  position: relative;
}

.question-mark:hover .plan-questionTxt {
  display: block;
}

.plan-questionTxt {
  text-align: left;
  display: none;
  position: absolute;
  width: 255Px;/*no*/
  border: 1Px solid #5562b4;/*no*/
  border-radius: 3Px;/*no*/
  left: 10Px !important;/*no*/
  top: 18Px !important;/*no*/
  background: #fff;
  z-index: 3;
  font-size: 12Px;/*no*/
  box-sizing: border-box;
  padding: 5Px;/*no*/
  line-height: 20Px;/*no*/
  color: #333333;
}
</style>


// WEBPACK FOOTER //
// src/components/popup/email_exploer_popups/paste_options_popup.vue